import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'phone',
    standalone: false
})
export class PhonePipe implements PipeTransform {
  transform(value: string | number): string {
    let digits = value?.toString().replace(/\D/g, '');
    if (digits.length === 11) {
      digits = digits.slice(1);
    }
    if (digits.length !== 10) {
      return value?.toString() || '';
    }
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
}
